import React from "react";
import styles from './modal.module.css';

const Backdrop = ({onClick=() => {}, children,className, dark,open,...props}) => {
    return (
        <div onClick={onClick} className={`${styles.Backdrop}
         ${dark? styles.dark : ""} ${open ? styles.open : ""}
         ${className || ""}`}
        {...props}>
            {children}
        </div>
    )
}

export default Backdrop;